var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.appLoaded || _vm.appLoading)?[_c('div',{staticClass:"center-loading"},[_c('spinner')],1)]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }